<div class="b-radius-max _outer"
     [class.b-a]="selected || isCheckbox()"
     [ngClass]="isCheckbox() ? 'b-col-b' : 'b-col-12'">

    <div class="b-radius-max ratio-1-1">
        @switch (getType()) {
        <!-- image -->
        @case ('image') {
        <img class="b-radius-max b-col-5 b-a"
             [fill]="true"
             [ratio]="1"
             [dfImage]="swatch" />
        }
        <!-- color -->
        @case ('background') {
        <span class="fill b-radius-max b-col-5 b-a"
              [style.background-color]="swatch"></span>
        }
        <!-- checkbox -->
        @default {
        <span class="fill b-radius-max bg-col-b"></span>
        }
        }
    </div>
</div>
